(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atf-collection"] && !Shopify.designMode) return;
  try {
    

/*
  ================================================================
  KYTE ATF COLLECTION
  Minimal JavaScript only.

  FAQ uses native <details> elements, so no JS is required for
  normal functionality.

  This script only improves the visual + accessibility state of
  the FAQ summary. It does not fetch data, call APIs or render
  critical content.
  ================================================================
*/

(function () {

  function initKyteATF(root) {

    if (!root || root.dataset.atfReady === 'true') {
      return;
    }

    root.dataset.atfReady = 'true';

    var details = root.querySelectorAll('.kyte-atf__faq details');

    details.forEach(function (item) {

      item.addEventListener('toggle', function () {

        if (!item.open) {
          return;
        }

        details.forEach(function (other) {

          if (other !== item && other.open) {
            other.open = false;
          }

        });

      });

    });

  }


  function initAllKyteATF() {

    document
      .querySelectorAll('[data-kyte-atf]')
      .forEach(initKyteATF);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAllKyteATF,
      { once: true }
    );

  } else {

    initAllKyteATF();

  }


  /*
    Shopify Theme Editor support.
    This does not run on normal storefront navigation unless
    Shopify emits the section load event.
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section = event.target;

      if (!section) {
        return;
      }

      var root = section.querySelector
        ? section.querySelector('[data-kyte-atf]')
        : null;

      if (root) {
        initKyteATF(root);
      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manual-transmission"] && !Shopify.designMode) return;
  try {
    

/*
  Minimal section JavaScript.
  Native <details> handles FAQ interaction.
  No API calls.
  No external libraries.
  No continuous animation.
*/

(function(){

  var sections = document.querySelectorAll('.mtf-collection-page');

  if(!sections.length){
    return;
  }

  sections.forEach(function(section){

    var faqItems = section.querySelectorAll('.mtf-faq details');

    faqItems.forEach(function(item){

      item.addEventListener('toggle',function(){

        if(!item.open){
          return;
        }

        faqItems.forEach(function(other){

          if(other !== item){
            other.removeAttribute('open');
          }

        });

      });

    });

  });

})();


  } catch(e) { console.error(e); }
})();
})();
